import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { formatDate } from '../../../../../utils'; // Assuming you have a formatDate function

const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '20%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '20%',
    padding: 5,
    textAlign: 'center'
  }
};

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];
export const StockTransferReportPdf = ({ data }) => {
  console.log('StockTransferReportPdf Data:', data);
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Good Receipt Note Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            
            {/* Loop through all GRNs in the data array */}
            {data.map((grn, grnIndex) => (
              <View key={grnIndex} style={{ marginBottom: 20 }}>
                {/* Display GRN Header Details */}
                <Text style={{ fontSize: '8px' }} content={`GRN No: ${grn.cnt}`} />
                <Text style={{ fontSize: '8px' }} content={`Date: ${formatDate(grn.grn_date)}`} />
                <Text style={{ fontSize: '8px' }} content={`Invoice No: ${grn.invoice_no}`} />
                <Text style={{ fontSize: '8px' }} content={`Supplier: ${grn.supplier._id}`} />
                <Text style={{ fontSize: '8px' }} content={`Remarks: ${grn.remarks}`} />
                
                {/* Table Header */}
                <View style={styles.row}>
                  <Text style={styles.columnHeader} content="Sr" />
                  <Text style={styles.columnHeader} content="Product Name" />
                  <Text style={styles.columnHeader} content="Quantity" />
                  <Text style={styles.columnHeader} content="Batch No" />
                  <Text style={styles.columnHeader} content="Expiry Date" />
                  <Text style={styles.columnHeader} content="Rate" />
                  <Text style={styles.columnHeader} content="Amount" />
                  <Text style={styles.columnHeader} content="GST (%)" />
                </View>

                {/* Loop through add_details for the current GRN */}
                {grn.add_details.map((item, index) => (
                  <View
                    key={index}
                    style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}
                  >
                    <Text style={styles.columnContent} content={index + 1} />
                    <Text style={styles.columnContent} content={item.product._id || 'N/A'} />
                    <Text style={styles.columnContent} content={item.total_qty || 0} />
                    <Text style={styles.columnContent} content={item.batch_no || 'N/A'} />
                    <Text style={styles.columnContent} content={formatDate(item.exp_date)} />
                    <Text style={styles.columnContent} content={item.rate || 0} />
                    <Text style={styles.columnContent} content={item.amount || 0} />
                    <Text style={styles.columnContent} content={item.gst || 0} />
                  </View>
                ))}
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default StockTransferReportPdf;
